import React, { useState, useEffect } from 'react';
import { FileText, MessageSquare } from '../../icons';

const FloatingWidgets: React.FC = () => {
    const [isInitial, setIsInitial] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsInitial(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    // Base classes for the widget container
    const baseClasses = "group flex flex-col items-center w-10 shadow-xl rounded-l-xl transition-all duration-700 ease-in-out overflow-hidden";

    // Dynamic height classes: Initial (Tall) -> Timeout (Short) -> Hover (Tall)
    // Using max-h for smooth CSS transition
    // Increased max-h to 80 (320px) to accommodate upright "GRIEVANCE" text
    const dynamicClasses = isInitial
        ? "max-h-80 py-4"
        : "max-h-12 py-3 hover:max-h-80 hover:py-4";

    return (
        <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-50 flex flex-col gap-4">
            {/* Report Issue / SOP */}
            <a
                href="/sop"
                className={`${baseClasses} bg-blue-600 text-white ${dynamicClasses}`}
                title="Standard Operating Procedures"
            >
                <FileText className="w-5 h-5 flex-shrink-0 mb-3" />
                <span className={`font-bold text-[10px] uppercase tracking-widest [writing-mode:vertical-rl] [text-orientation:upright] whitespace-nowrap transition-opacity duration-300 ${isInitial ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
                    SOP
                </span>
            </a>

            {/* Lodge Grievance */}
            <a
                href="/grievance"
                className={`${baseClasses} bg-green-600 text-white ${dynamicClasses}`}
                title="Lodge Grievance"
            >
                <MessageSquare className="w-5 h-5 flex-shrink-0 mb-3" />
                <span className={`font-bold text-[10px] uppercase tracking-widest [writing-mode:vertical-rl] [text-orientation:upright] whitespace-nowrap transition-opacity duration-300 ${isInitial ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
                    Grievance
                </span>
            </a>
        </div>
    );
};

export default FloatingWidgets;
